import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 100,
    color: '#fff',
  },
});

const LoadingOverlay = (props) => {
  return (
    <Backdrop open={props.loading} className={props.classes.backdrop}>
      <CircularProgress color="primary" />
    </Backdrop>
  );
}

export default withStyles(styles)(LoadingOverlay);
